var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_845)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.37259 24 0 18.6274 0 12C0 5.37258 5.37259 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM7.27501 8.77501C7.34999 8.85 7.425 9 7.425 9.15001V14.4C7.5 14.625 7.425 14.775 7.27501 14.925L6 16.425V16.65H9.52501V16.425L8.25 14.925C8.175 14.775 8.09999 14.625 8.09999 14.4V9.825L11.25 16.65H11.55L14.25 9.825V15.3C14.25 15.45 14.25 15.525 14.175 15.6L13.2 16.575V16.8H17.925V16.575L17.025 15.675C16.95 15.6 16.95 15.45 16.95 15.375V8.625C16.875 8.475 16.95 8.40001 17.025 8.325L18 7.42501V7.2H14.7L12.3 13.125L9.59999 7.2H6.15001V7.42501L7.27501 8.77501Z",
    fill: "currentcolor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ee30ce008ee0117049b135eff94d8c73.svg";
export { ForwardRef as ReactComponent };